
export function createTickerLink(exchange, ticker, pair) {
    switch (exchange) {
        case 'BINANCE': {
            return `https://www.binance.com/ru/trade/pro/${ticker}_${pair}`
        }
        case 'KUCOIN': {
            return `https://trade.kucoin.com/spot/${ticker}_${pair}?lang=en_US`
        }
        case 'BITTREX': {
            return `https://global.bittrex.com/Market/Index?${ticker}-${pair}`
        }
        case 'HUOBI': {
            return `https://www.huobi.co/ru-ru/exchange/${ticker.toLowerCase()}_${pair.toLowerCase()}`;
        }
    }

}
